import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable max-len */
import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { ConnectedConversation, ConversationStoreProvider, SelectionWizardProvider, sharedConversationMeta } from '@mcn-platform/converse-lib';
import { useStore } from '@mcn-platform/models';
import ConversationStoreAdapter from './ConversationStoreAdapter';
const ConversationWidget = ({ limitToPageWidth, enableVoiceInput, showItemReferencesWithMessage = true, showItemReferencesCarousel = false, showPersistentPrompts, showResetWithInput = true, courseCardShowImage, courseCardShowTitle, courseCardShowInstructor, courseCardShowDescLines, clientAIAnimatedProcessingIcon, openWebPagesInNewTab, style, questionStyle, responseStyle, feedbackButton, questionAlignment, responseAlignment, referenceFormatting, inputStyle, startingMessageFontStyle, adminOptions, sendImage, resetConversationLabel, agentAvatarImage, userAvatarImage, hideRightRailOnMobile, maxItemsInRightRail, enableMultiRefinements, multiRefinementSubmitButtonText, productFormatting, agentName, onProductClick, layoutMode, }) => {
    const store = useStore();
    const navigate = useNavigate();
    const onPortalRelativeNavigate = useCallback((relativePath) => {
        if (relativePath)
            navigate(relativePath);
    }, [navigate]);
    return (_jsx(ConversationStoreProvider, { value: new ConversationStoreAdapter(store), children: _jsx(SelectionWizardProvider, { children: _jsx(ConnectedConversation, { limitToPageWidth: limitToPageWidth, enableVoiceInput: enableVoiceInput, showItemReferencesWithMessage: showItemReferencesWithMessage, showItemReferencesCarousel: showItemReferencesCarousel, courseCardShowImage: courseCardShowImage, courseCardShowTitle: courseCardShowTitle, courseCardShowInstructor: courseCardShowInstructor, courseCardShowDescLines: courseCardShowDescLines, openWebPagesInNewTab: openWebPagesInNewTab, style: style, questionStyle: questionStyle, responseStyle: responseStyle, feedbackButton: feedbackButton, questionAlignment: questionAlignment, responseAlignment: responseAlignment, referenceFormatting: referenceFormatting, inputStyle: inputStyle, startingMessageFontStyle: startingMessageFontStyle, adminOptions: adminOptions, sendImage: sendImage, agentAvatarImage: agentAvatarImage, userAvatarImage: userAvatarImage, resetConversationLabel: resetConversationLabel, showPersistentPrompts: showPersistentPrompts !== false, showResetWithInput: showResetWithInput, hideRightRailOnMobile: hideRightRailOnMobile, enableMultiRefinements: enableMultiRefinements, multiRefinementSubmitButtonText: multiRefinementSubmitButtonText, animatedProcessingImage: clientAIAnimatedProcessingIcon, maxItemsInRightRail: maxItemsInRightRail, productFormatting: productFormatting, agentName: agentName, onProductClick: onProductClick, onPortalRelativeNavigate: onPortalRelativeNavigate, layoutMode: layoutMode, conversationType: "shoppingAssistant" }) }) }));
};
ConversationWidget.defaultProps = {
    ...ConnectedConversation.defaultProps,
};
ConversationWidget.meta = {
    group: 'portal',
    name: 'AI Conversation',
    sort: 40,
    description: 'Conversation widget to interact with platform.',
    props: [
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
        },
        {
            key: 'showItemReferencesWithMessage',
            name: 'Show Item References With Message',
            type: 'boolean',
            description: 'Displays relevent content next to the message.',
        },
        {
            key: 'showItemReferencesCarousel',
            name: 'Show Item References Carousel',
            type: 'boolean',
            description: 'Displays a carousel of relevent content below the chat thread.',
        },
        {
            key: 'style',
            name: 'Widget Style',
            type: 'boxStyle',
            description: 'Style of widget.',
            group: 'style',
        },
        {
            key: 'agentName',
            name: 'Agent Name',
            type: 'text',
            description: 'Optional agent identifier for AI reporting.',
        },
        ...sharedConversationMeta,
    ],
    defaultConfig: {
        type: 'component',
        component: 'ConversationWidget',
        props: ConversationWidget.defaultProps,
    },
};
export default observer(ConversationWidget);
//# sourceMappingURL=ConversationWidget.js.map